/**
 * Saída de um formulário que pergunta antes de descartar — C-91 (Gabriel, 18/10/2026).
 *
 * ×, Esc, Cancelar/Fechar/Voltar e clique fora chamam o MESMO `pedirFechar`:
 * - nada preenchido → fecha direto;
 * - algo preenchido → abre "Descartar o que foi preenchido?" (`ConfirmarDescarte`);
 * - enviando → não faz nada (o formulário não some no meio da gravação).
 *
 * A gravação bem-sucedida fecha pelo `fechar` direto, sem pergunta.
 */
import { useState } from 'react';

export interface OpcoesFecharComConfirmacao {
  /** Há algo digitado/escolhido que se perde ao fechar. */
  preenchido: boolean;
  /** Gravando: fechar fica travado. */
  ocupado?: boolean;
  fechar: () => void;
}

export function useFecharComConfirmacao({ preenchido, ocupado = false, fechar }: OpcoesFecharComConfirmacao) {
  const [perguntando, setPerguntando] = useState(false);
  return {
    perguntando,
    pedirFechar() {
      if (ocupado) return;
      if (preenchido) setPerguntando(true);
      else fechar();
    },
    continuar() {
      setPerguntando(false);
    },
    descartar() {
      // A pergunta pode estar aberta quando o envio começa: não fecha no meio dele.
      if (ocupado) return;
      setPerguntando(false);
      fechar();
    },
  };
}
